'use client';

import { useContext } from 'react';
import { MomentoContext } from '@/components/momento/MomentoContext';

export function useMomento() {
  const context = useContext(MomentoContext);

  if (context === undefined) {
    throw new Error('useMomento must be used within a MomentoProvider');
  }

  return context;
}
